import { Box, Container, useMediaQuery } from "@mui/material";
import { useAbility } from "@casl/react";
import { AbilityContext } from "../../permission/Can";
import { Actions, Subjects } from "../../permission/constants";

import Menu from "../Menu/Menu";
import MenuMobile from "../Menu/MenuMobile";
import UserMenu from "../UserMenu/UserMenu";
import Logo from "../Logo/Logo";

const MenuBar = () => {
  const matches = useMediaQuery("(min-width:1200px)");
  const ability = useAbility(AbilityContext);

  return (
    <Container
      maxWidth={"xl"}
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        columnGap: { xs: 1, md: 4 },
        padding: "1.5rem 0.5rem",
      }}
    >
      <Logo />
      {ability.can(Actions.VIEW, Subjects.MENU) && matches && <Menu />}
      <Box display={"flex"}>
        <UserMenu aria-label="UserMenu" />
        {ability.can(Actions.VIEW, Subjects.MENU) && matches === false && (
          <MenuMobile />
        )}
      </Box>
    </Container>
  );
};

export default MenuBar;
